
<template>
  <el-dialog
      title="请选择"
      v-model="dialogVisible"
      width="90%"
      top="35vh"
      custom-class="mobile-dialog"
      @close="handleClose"
  >
    <el-select
        v-model="selectedValue"
        placeholder="请选择"
        class="mobile-select"
        @change="handleChange"
    >
      <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
      />
    </el-select>
    <div class="dialog-footer margin-20-0">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmSelect">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {ElMessage,ElDialog,ElSelect,ElOption,ElButton} from "element-plus";

export default {
  name:"mobileSel",
  components:{ElDialog,ElSelect,ElOption,ElButton},
  data() {
    return {
      dialogVisible: false,
      selectedValue: '',
      options: [
      ]
    }
  },
  methods: {
    open(data) {
      this.dialogVisible = true
      this.options = data
    },
    handleClose() {
      this.selectedValue = ''
    },
    handleChange(val) {
      console.log('当前选择:', val)
    },
    confirmSelect() {
      if (!this.selectedValue) {
        ElMessage.warning('请先选择选项')
        return
      }
      this.$emit('confirm', this.selectedValue)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.mobile-select {
  width: 100%;
}

.mobile-dialog {
  border-radius: 8px;
}

.dialog-footer {
  text-align: center;
}
</style>
